import moment from 'moment';

import { RescheduleTechnicianFormModel } from 'app/page/orders/reschedule-technician/reschedule-technician-form-model';

export class RescheduleTechnicianMapper {
    public static mapAppointmentForm(appointment: OrderTrackerBackend.Appointment): RescheduleTechnicianFormModel {
        return {
            installationDate: appointment.date,
            installationHour: appointment.timeSlot,
            contactName: appointment.contactName!,
            phoneNumber: appointment.contactPhone!,
            rightOfWithdrawalIsAgreed: false,
            technicianCanContactMe: false,
        };
    }

    public static mapAppointment(appointment: RescheduleTechnicianFormModel): OrderTrackerBackend.Appointment {
        return {
            date: appointment.installationDate,
            timeSlot: appointment.installationHour,
            contactName: appointment.contactName,
            contactPhone: appointment.phoneNumber,
        };
    }

    public static findDayTimeSlots(
        slots: OrderTrackerBackend.DayTimeSlots[],
        day: moment.Moment,
    ): ('MORNING' | 'AFTERNOON')[] {
        const daySlots: OrderTrackerBackend.DayTimeSlots | undefined = slots.find((daySlot) =>
            day.isSame(moment(daySlot.date), 'day'),
        );

        return daySlots?.timeSlots || [];
    }
}
